<template>
    <div style="height: 100%;">
        <entity-list
                :entities="aois"
                :operations="[]"
                :isDisabled="isDisabled"
                :groupBy="groupBy"
                :selectedEntity.sync="selectedEntity"
                @removeButtonClick="onRemoveAoiButtonClick"
        >
            <admin-aoi-list-item slot-scope="{item}"
                                 :aoi="item"
                                 @acceptButtonClick="onAcceptButtonClick"
                                 @rejectButtonClick="onRejectButtonClick"
                                 @addResultButtonClick="onAddResultButtonClick"
                                 @downloadResultButtonClick="onDownloadResultButtonClick"
            />
        </entity-list>
        <reject-dialog
                :rejectionReasons="rejectionReasons"
                :show.sync="showRejectDialog"
                @rejectionReasonSelected="onRejectionReasonSelected"
        />
        <upload-file-dialog
                :show.sync="showUploadFileDialog"
                :uploadURL="uploadURL"
                :idToken="idToken"
                :aoiId="uploadImageAoiId"
        />
    </div>
</template>

<script>
    import Vue from 'vue'

    import EntityList from '@/components/entity-list/entity-list.vue'
    import AdminAoiListItem from './admin-aoi-list-item'
    import RejectDialog from './rejected-dialog'
    import UploadFileDialog from './upload-file-dialog'

    import moment from 'moment'

    moment.locale('ru');

    export default {
        props: {
            aois: {
                type: Array,
                default: () => []
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            selectedAoi: {
                type: String,
                default: null
            },
            uploadURL: {
                type: String,
                required: true
            },
            idToken: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                selectedEntity: this.selectedAoi,
                groupBy: (item) => {
                    let today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return +today < item.creationTime ? 'Сегодня' :
                        moment(item.creationTime).format(moment(today).year() === moment(item.creationTime).year() ? "D MMMM" : "D MMMM YYYY");
                },
                showRejectDialog: false,
                showUploadFileDialog: false,
                rejectedAoi: null,
                rejectionReasons: [
                    "Регион не соотвествует условиям задания",
                    "Отказ на съемку"
                ],
                uploadImageAoiId: null
            }
        },
        computed: {},
        methods: {
            onRemoveAoiButtonClick(aoiId) {
                this.$emit('removeButtonClick', aoiId);
            },
            updateSelectedAoi(val) {
                if (val !== this.selectedAoi)
                    this.$emit('update:selectedAoi', val);
            },
            onDownloadResultButtonClick(aoiId){
                this.$emit('downloadResultButtonClick', aoiId);
            },
            onAcceptButtonClick(aoiId) {
                this.$emit('entityUpdated', {
                    id: aoiId,
                    data: {
                        status: 'inProcessing'
                    }
                });
            },
            onAddResultButtonClick(aoiId) {
                this.uploadImageAoiId = aoiId;
                this.showUploadFileDialog = true;
            },
            onRejectButtonClick(aoiId) {
                this.showRejectDialog = true;
                this.rejectedAoi = aoiId;
            },
            onRejectionReasonSelected(rejectionReason) {
                this.$emit('entityUpdated', {
                    id: this.rejectedAoi,
                    data: {
                        status: 'rejected',
                        statusMessage: rejectionReason
                    }
                });
            }
        },

        components: {
            EntityList,
            AdminAoiListItem,
            RejectDialog,
            UploadFileDialog
        },

        watch: {
            selectedEntity(newVal) {
                this.updateSelectedAoi(newVal);
            },
            selectedAoi(newVal) {
                this.selectedEntity = newVal;
            }
        }
    }
</script>

<style scoped>

</style>
